<template>
  <FilterGroup title="Lieu">
    <FilterButton
      label="Tout"
      :active="filter === null"
      @click.native="$emit('updateFilter', null)"
    />
    <FilterButton
      label="Trébeurden"
      icon="fish"
      color="blue"
      :active="filter === 'trebeurden'"
      @click.native="$emit('updateFilter', 'trebeurden')"
    />
    <FilterButton
      label="Robertville"
      icon="tree"
      color="green"
      :active="filter === 'robertville'"
      @click.native="$emit('updateFilter', 'robertville')"
    />
  </FilterGroup>
</template>

<script>
import FilterButton from './FilterButton.vue';
import FilterGroup from './FilterGroup.vue';

export default {
  components: {
    FilterButton,
    FilterGroup,
  },

  props: ['filter'],
};
</script>
